<template>
  <div id="app">
    <router-view/>
	<!-- 图片选择 -->
	<imageDialog ref="imageDialog" :max="maxChooseImage"></imageDialog>
	<!-- 图片查看 -->
	<preview ref="preview" :previewModel="previewModel" :previewUrl="previewUrl" @changePreview="changePreview"></preview>
	<!-- 规格列表 -->
	<skuDialog ref="skuDialog"></skuDialog>
  </div>
</template>

<script>
	import imageDialog from "@/components/image/image_dialog.vue"
	import preview from "@/components/image/preview.vue"
	import skuDialog from "@/components/goods/sku_dialog.vue"
	export default {
		components: {
		  	 imageDialog,
		     preview,
			 skuDialog
		},
		data() {
			return {
				maxChooseImage: 9,
				previewModel:false,
				previewUrl:'',
			}
		},
		provide(){
		  return {
			  app:this
		  }
		},
		created() {
			document.title = ''
			this.shopConf()
		},
		methods:{
			//选择图片
			chooseImage(callback,max=9){
			  this.maxChooseImage = max
			  this.$refs.imageDialog.selImage(callback)
			},
			previeImage(url){
			  this.previewModel = true
			  this.previewUrl = url
			},
			changePreview(e){
			  this.previewModel = e
			},
			//选择规格
			chooseSkus(callback){
			  this.$refs.skuDialog.chooseSkus(callback)
			},
			shopConf(){
			  this.axios.get('/manage/shopConf')
			  .then(res=>{
				this.$nextTick(()=> {
				  this.$store.commit('config',res.data)
				  document.title = res.data.shop_name || '';
				})
			  })
			},
		}
	}
</script>
<style lang="scss">
@import url("./assets/css/reset.css");
@import url("./assets/css/bootstrap.min.css");
@import url("./assets/css/common.css");

</style>
